/** Terms & Privacy — 简体中文。目前主要为一对一；群组、频道与审核或于日后加入。 */
export const legalDocumentsZh = {
  termsFull: `1. 接受本条款

创建账户、登录或使用 Duvpost（「本服务」「我们」），即表示您同意本服务条款。若不同意，请勿使用本服务。

2. Duvpost 是什么

Duvpost 是一款即时通讯与实时通信的 Web 应用，以小规模运营。

目前产品侧重于一对一实时聊天、文件附件、用户之间的语音与视频通话、通过链接的类 Meet 房间，以及通过邮箱/密码或 Google 登录的账户（例如 People 的发现与个人资料）。群组对话、频道及专门审核流程并非当前版本的必备功能，但日后可能在不另行与您达成协议的情况下推出；若推出，本条款同样适用于这些功能。

我们可能随时新增、变更或下线功能。并非本文所述的所有功能在您的地区、套餐或应用版本中始终可用。

本服务使用 Google Firebase（Authentication、Firestore、Storage、Cloud Functions 及相关基础设施）及隐私政策中描述的其他组件。

3. 资格

年满 16 周岁或您所在司法辖区的最低年龄。未成年人仅在监护人同意下使用。我们不会故意收集适用年龄以下儿童的数据。

4. 您的账户

信息真实、凭据安全，并对您账户下的活动负责。如怀疑账户被入侵，请通过已公布的联系方式通知我们。

对于付费方案（例如「Premium」），费用、计费周期与税费将在购买时显示。欠费可能导致降级或丧失付费功能。

5. 方案、存储限额与保留

我们可能提供不同账户层级（例如标准/免费与付费）。限额——例如最大文件大小、总存储、并发上传或附件在若干时间后自动删除——可能因方案而异并可能变更。除法律另有要求外，我们将在合理情况下尽力提前通知重大变更（例如应用内、电子邮件或更新后的条款）。

在有限方案下，已上传文件可能在我们指明的期限后或因超出配额而被自动删除。更高方案可提供更大限额、更长保留或更少限制；「无限」仍受合理使用与反滥用政策约束。

您应自行备份重要数据。当前服务将聊天消息和上传的聊天文件自创建起保留 14 天，随后自动删除。我们不保证对用户内容的无限期、无限制存储。

6. 用户内容

您保留对内容的所有权。您授予我们在运营和保护本服务、执行本条款及遵守法律所必需的范围内，有限的、全球性的、非独占的许可，以托管、存储、复制、传输和展示您的内容——包括一对一聊天、通话、Meet，以及在提供时的群组、频道及相关功能。

我们不主张对您内容的所有权。消息内容可能以加密形式存储；详见隐私政策。您对合法性及第三方权利负责。在存在群组或频道时，同样适用适用法律及本条款；我们可能发布附加规则。

7. 可接受的使用

禁止包括但不限于：非法、有害、骚扰或歧视性使用；恶意软件/钓鱼；未经授权的访问；滥用 API；冒充；侵犯知识产权或隐私；垃圾信息；在提供时利用开放或可发现的频道及类似功能传播非法内容。

在法律或本条款要求时，我们可能暂停访问或删除、限制内容。我们没有监控所有用户通信的一般义务；若引入举报或审核工具，使用这些工具并不保证任何特定响应时间或结果。

8. 通话与第三方基础设施

语音/视频（包括若我们增加的群组通话）：点对点或中继（TURN）。网络与中继运营商按其政策处理。浏览器/操作系统权限由您控制。

9. 第三方服务

Google/Firebase；支付通过各自条款的支付处理商。链接预览可能向第三方站点发起请求。

10. 知识产权

Duvpost 商标与软件（除您的内容外）受保护。

11. 免责声明

本服务按「现状」和「可用时」提供。在法律允许的最大范围内，我们否认一切明示、默示或法定的保证，包括适销性、特定用途适用性、安静享用和不侵权。

我们不保证不间断或无错误运行、缺陷将得到纠正、我们的服务器不含有害组件，或数据永不丢失、损坏或披露。本服务不是备份存档，不替代专业医疗、法律或财务建议，不是紧急服务，也不是法律或监管义务的记录系统（除非我们另有明确书面约定）。

我们对其他用户发送内容的准确性、合法性或质量不承担责任。您使用本服务并依赖任何内容的风险由您自行承担。

12. 责任限制

在法律允许范围内，我们、我们的供应商、董事和人员不对任何间接、附带、特殊、后果性或惩罚性损害，或利润、收入、数据、商誉或机会损失承担责任，即使已被告知可能发生此类损害。

因本服务或本条款引起的所有索赔，我们的总责任以 (a) 索赔发生前 12 个月内您为本服务支付的金额与 (b) 若无付款则为 50 欧元二者较高者为上限。无论索赔基于合同、侵权（含过失）还是严格责任，除非法律禁止此类限制（例如因我们过失导致的死亡或人身伤害、欺诈）。

若您所在司法辖区不允许某些限制，我们的责任以法律允许的最大范围为限。

13. 赔偿

除我们故意不当行为外，您应就因您使用、您的内容或您违反本条款而产生的索赔、损害、损失及合理法律费用向我们作出赔偿。

14. 终止

您可随时停止使用；我们可在违约、安全风险、欠费或法律要求时暂停服务。按其性质应继续有效的条款（责任限制、赔偿、适用法律）在终止后继续有效。

15. 变更

我们可能更新本条款及「最后更新」日期。重大变更依法可能需要额外通知或同意。变更生效后继续使用，除法律另有要求外，视为接受。

16. 适用法律与争议

本条款受本服务运营商注册办事处或主要营业地所在国法律管辖，不影响您惯常居住国对您的强制性消费者保护规则。

若您为惯常居住在欧洲经济区的消费者，在法律规定的情况下可援引您居住国法律的强制性规定，并在法律要求时向您居住地法院对我们提起诉讼。我们可在我们的设立地法院或法律允许的您居住国法院对您提起诉讼。

17. 其他

若某条款无效，其余条款仍然有效。本条款与隐私政策及购买时展示的套餐专用条款构成您与我们之间关于本服务的完整协议。未经我们同意，您不得转让权利；我们可在合并、收购或资产出售时转让。未行使权利不构成放弃。对合理控制范围外原因（不可抗力）造成的延迟或失败，我们不承担责任。

18. 联系方式

有关本条款的问题，请通过应用（例如 About）或网站公布的运营商联系方式联系。

最后更新：2026 年 3 月`,

  privacyFull: `1. 引言

本隐私政策说明使用 Duvpost 时个人数据的处理方式。补充服务条款。

本服务以小规模运营；功能可能扩展（群组聊天、频道、群组通话、付费方案、审核工具）。本政策描述与已部署产品及合理预期演进相一致的处理方式。

2. 控制者

您所用 Duvpost 部署的运营方，在应用（例如 About）或域名上标明。请求请使用公布的联系方式。

3. 处理的数据

视使用情况而定：账户/身份验证、个人资料/发现（People）、消息（目前主要一对一；若增加则为群组会话）、若提供则为频道、带方案限额与保留的附件、若存在则含群组的通话/Meet、支付/订阅、技术数据、App Check/reCAPTCHA、本地存储、链接预览。我们不会将聊天内容用于训练公开的 AI 模型。

4. 目的与法律依据

履行合同、安全、配额、保留、法定义务、交易邮件、支付。若引入营销/非必要 Cookie，将另行取得同意。

5. 处理者

Google Firebase 及相关 Google 服务。当前列表与文档：https://firebase.google.com/support/privacy 以及 Google Cloud/Firebase 数据处理条款。可能还有支付处理商、托管、邮件。

6. 跨境传输

如 Google/Firebase 常见做法，例如标准合同条款。

7. 保留

聊天消息（Firestore 中的密文）和 Storage 中的附件自创建起保留 14 天，随后自动删除。账户、资料和联系人等服务数据在账户有效且提供服务所需期间保留。备份/日志有限。删除账户后在可行范围内删除或匿名化；群组/频道数据在其他成员处按产品逻辑处理。

8. 安全

HTTPS、规则、可能的客户端加密、App Check、标头 — 见技术文档。

9. 个人数据泄露

若我们知悉导致我们控制的个人数据遭受意外或非法销毁、丢失、更改或未经授权披露的安全漏洞，我们将采取合理措施减轻损害，并在法律要求时毫不迟延地通知监管机构及/或受影响个人。

10. 您的权利

视所在地而定：访问、更正、删除、限制、反对、可携带性、向监管机构投诉。

11. 自动化决策

我们不将您的个人数据用于对您产生法律效力或类似重大影响的纯自动化决策，除非我们另行通知并说明法律依据。

12. 儿童

不低于条款规定的最低年龄。

13. Cookie

登录/会话所必需；其他仅在告知及（如适用）同意后使用。

14. 变更

我们可能更新本政策。

15. 联系方式

隐私请求请联系公布的运营方。

最后更新：2026 年 3 月`,
} as const;
